import React from "react";

const PageTitle = props => (
  <h1 style={{ marginBottom: 50 }}>{props.children}</h1>
);

export default PageTitle;
